import Vue from 'vue'
import VueOrganizationChart from 'vue-organization-chart'
import 'vue-organization-chart/dist/orgchart.css'
Vue.use(VueOrganizationChart)

export default {
  VueOrganizationChart
}